import axios from "axios";
import { z } from "zod";
import { customerApiUrl } from "api-url";
import { BaseErrorResponse } from "api/responses";
import { createQueryRequestHook } from "shared/hooks/createQueryRequestHook";
import { transformInitialETAPieChartData } from "../utils/chart.utils";
import { useInventoryViewTranslation } from "shared/hooks/useInventoryViewTranslation";

const intialETAPieChartResponseSchema = z.object({
  initialETARanges: z.object({
    hours0_47: z.number(),
    hours48_95: z.number(),
    hours96_inf: z.number(),
    hoursPast72_1: z.number(),
    hoursPast72: z.number(),
    total: z.number(),
  }),
});

type InitialETAPieChartResponse = z.infer<
  typeof intialETAPieChartResponseSchema
>;

const useInitialETAQuery = () => {
  return createQueryRequestHook<InitialETAPieChartResponse, BaseErrorResponse>({
    queryKey: ["initialETA"],
    queryFn: async () => {
      const url = customerApiUrl(
        `/entity-inventory/organization/metrics/initial-eta`,
      );
      const response = await axios.get(url);
      return response.data;
    },
    initialData: {
      initialETARanges: {
        hours0_47: 0,
        hours48_95: 0,
        hours96_inf: 0,
        hoursPast72_1: 0,
        hoursPast72: 0,
        total: 0,
      },
    },
    refetchOnWindowFocus: false,
    retry: false,
  })();
};

export const useInitialETARangesPieChart = () => {
  const { getTranslatedInitialETALabels } = useInventoryViewTranslation();

  const { data, isFetching, isError } = useInitialETAQuery();
  let transformedData = transformInitialETAPieChartData(data);

  let translatedData = transformedData.map((item: any) => {
    return {
      ...item,
      name: getTranslatedInitialETALabels(item.name),
      value: item.name,
    };
  });

  return { pieChartData: translatedData, isFetching, isError };
};
